import { Action } from '@ngrx/store'
import * as SecuritySettingsTypes from './security-settings.types'

export class FetchSecuritySettingsRequest implements Action {
  readonly type = SecuritySettingsTypes.FETCH_SECURITY_SETTINGS_REQUEST
  constructor() {}
}

export class FetchSecuritySettingsSuccess implements Action {
  readonly type = SecuritySettingsTypes.FETCH_SECURITY_SETTINGS_SUCCESS
  constructor(public payload: any) {}
}

export class FetchSecuritySettingsFailure implements Action {
  readonly type = SecuritySettingsTypes.FETCH_SECURITY_SETTINGS_FAILURE
  constructor(public payload: any) {}
}

export class UpdateSecuritySettingsRequest implements Action {
  readonly type = SecuritySettingsTypes.UPDATE_SECURITY_SETTINGS_REQUEST
  constructor(public payload: any) {}
}

export class UpdateSecuritySettingsSuccess implements Action {
  readonly type = SecuritySettingsTypes.UPDATE_SECURITY_SETTINGS_SUCCESS
  constructor() {}
}

export class UpdateSecuritySettingsFailure implements Action {
  readonly type = SecuritySettingsTypes.UPDATE_SECURITY_SETTINGS_FAILURE
  constructor(public payload: any) {}
}

export class UpdateField implements Action {
  readonly type = SecuritySettingsTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class SetDefaultData implements Action {
  readonly type = SecuritySettingsTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export type Actions =
  | FetchSecuritySettingsSuccess
  | FetchSecuritySettingsFailure
  | FetchSecuritySettingsRequest
  | UpdateSecuritySettingsRequest
  | UpdateSecuritySettingsSuccess
  | UpdateSecuritySettingsFailure
  | SetDefaultData
  | UpdateField
